import { render, staticRenderFns } from "./ProjectTerminatedLifecycleSetter.vue?vue&type=template&id=c6bd4e9e"
import script from "./ProjectTerminatedLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectTerminatedLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports